<template>
  <div v-if="!(printMode && marking=='struckThrough')"
    class="description-card"
    :class="[marking, edit?'editStyle':'', viewMenu?'menuSelected':'' ]"
    ref="myCard"
    :id="id"
  >
    <div 
      class="card-content"        
      :class="{containsIcons: (marking=='warning') || (marking=='done') || (description.tooltip && !printMode)}" 
      @click="openMenu($event)"
    >
      <span class="myicon" v-if="(marking=='warning') || (marking=='done')">
        <alert-icon v-if="marking=='warning'" :title="$t('views.themeView.descriptionCard.markings.warning')" />
        <check-icon v-if="marking=='done'" :title="$t('views.themeView.descriptionCard.markings.done')" />
      </span>

      <help-circle-icon 
        v-if="description.tooltip && !printMode"
        @click="toggleTooltip($event)"
        class="icon-tooltip"
        title=""
        v-tooltip="description.tooltip"
      />

      <p class="dropdown-content" v-html="description_g"></p>
    </div>

    <ul @blur="closeMenu()"
      class="click-menu"
      tabindex="-1"
      ref="left"
      v-if="viewMenu"
    >
      <li @click="setMarking(null)" v-if="!!marking">
        <undo-icon title="" />{{ $t('views.themeView.descriptionCard.actions.cancelMarking')}}
      </li>

      <li class="warning" @click="setMarking('warning')" v-if="marking!='warning'">
        <alert-icon title="" />{{ $t('views.themeView.descriptionCard.actions.markWarning')}}
      </li>
      <li class="done" @click="setMarking('done')" v-if="marking!='done'">
        <check-icon title="" />{{ $t('views.themeView.descriptionCard.actions.markDone')}}
      </li>
      <li class="struckThrough" @click="setMarking('struckThrough')" v-if="marking!='struckThrough'">
        <format-strikethrough-variant-icon title="" />{{ $t('views.themeView.descriptionCard.actions.strikeThrough')}}
      </li>

      <li v-if="description.custom" @click="showAddElementPopin()" class="separatorBefore">
        <lead-pencil-icon title="" />{{ $t('views.themeView.descriptionCard.actions.edit')}}
      </li>
      <li v-if="description.custom" @click="showDeletePopin()">
        <inrs-delete-icon title="" />{{ $t('views.themeView.descriptionCard.actions.delete')}}
      </li>
    </ul>
  </div>
</template>


<script>
import LeadPencilIcon from 'vue-material-design-icons/LeadPencil.vue';
import InrsDeleteIcon from '../../icons/InrsDelete.vue';
import HelpCircleIcon from 'vue-material-design-icons/HelpCircle.vue';
import AlertIcon from 'vue-material-design-icons/Alert.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';
import UndoIcon from 'vue-material-design-icons/Undo.vue';
import FormatStrikethroughVariantIcon from 'vue-material-design-icons/FormatStrikethroughVariant.vue';

export default {
  name: "DescriptionCard",
  components: {
    LeadPencilIcon,
    InrsDeleteIcon,
    HelpCircleIcon,
    AlertIcon,
    CheckIcon,
    UndoIcon,
    FormatStrikethroughVariantIcon
  },
  props: {
    description: Object,
    edit: Boolean,
    subThemeRef: String,
    themeAbbr: String,
    dataType: String,
    printMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    id: function() {
      return "DescCard_"+this.description.ref;
    },
    description_g: function() {
      return JsonDataModule.getValueWithGlossary(this.description, 'description'); //eslint-disable-line no-undef
    }
  },
  created: function() {
    if (this.description.marking !== "") {
      this.marking = this.description.marking;
    }
  },
  mounted: function() {
    initTooltips("#"+this.id); //eslint-disable-line no-undef
  },  
  updated: function() {
    initTooltips("#"+this.id); //eslint-disable-line no-undef
  },  
  data: function() {
    return {
      toggleTooltipState: false,
      showDropDown: false,
      marking: null,
      viewMenu: false
    };
  },
  methods: {
    toggleTooltip: function(e) {
      this.toggleTooltipState = !this.toggleTooltipState;
      e.stopPropagation(); // évite que le menu déroulant s'ouvre lorsqu'on clique sur le picto (?)
    },
    closeMenu: function() {
      this.viewMenu=false
    },
    setMarking: function(marking) {
      var newData = {};
      if (this.dataType == "OBSERVATIONS") {
        newData = {
          type: "SET-MARKING-DESCRIPTION_SITUATION_ELEMENT",
          params: {
            themeAbbr: this.themeAbbr,
            subThemeRef: this.subThemeRef,
            descriptionRef: this.description.ref,
            marking: marking
          }
        };
      }
      if (this.dataType == "OBJECTIFICATIONS") {
        newData = {
          type: "SET-MARKING-OBJECTIFICATION_ELEMENT",
          params: {
            themeAbbr: this.themeAbbr,
            objectificationRef: this.description.ref,
            marking: marking
          }
        };
      }
      this.$store.dispatch("editThemeElement", newData);

      // met à jour manuellement la donnée sur la page affichée
      this.marking = null;
      this.marking = this.description.marking;
      // on cache le dropdown
      this.closeMenu();
    },
    showDeletePopin: function() {
      if (this.dataType == "OBSERVATIONS") {
        this.$store.commit("SET_POPIN", {
          themeAbbr: this.themeAbbr,
          subThemeRef: this.subThemeRef,
          descriptionRef: this.description.ref,
          type: "DEL-DESCRIPTION_SITUATION_ELEMENT"
        });
      }
      if (this.dataType == "OBJECTIFICATIONS") {
        this.$store.commit("SET_POPIN", {
          themeAbbr: this.themeAbbr,
          objectificationRef: this.description.ref,
          type: "DEL-OBJECTIFICATION_ELEMENT"
        });
      }
      this.$bvModal.show("deleteElement");
    },

    showAddElementPopin: function() {
      if (this.dataType == "OBSERVATIONS") {
        this.$store.commit("SET_POPIN", {
          themeAbbr: this.themeAbbr,
          subThemeRef: this.subThemeRef,
          descriptionRef: this.description.ref,
          description: this.description.description,
          type: "EDIT-DESCRIPTION_SITUATION_ELEMENT"
        });
      }
      if (this.dataType == "OBJECTIFICATIONS") {
        this.$store.commit("SET_POPIN", {
          themeAbbr: this.themeAbbr,
          objectificationRef: this.description.ref,
          description: this.description.description,
          type: "EDIT-OBJECTIFICATION_ELEMENT"
        });
      }

      this.$bvModal.show("addThemeElement");
    },
    openMenu: function(e) {
      if (this.edit) {
        this.viewMenu = true;
       this.$nextTick(
          function() {
            this.$refs.left.focus();
          }.bind(this)
        );
        e.preventDefault();
      }
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../../sass/_variables.sass"

.description-card
  background: $lightgray-4
  margin: 2px
  display: block
  border: 1px solid transparent
  cursor: default

  @media print
    background: transparent
    border: 1px solid $lightgray-1
    break-inside: avoid
    page-break-inside: avoid

  &.warning
    background-color: $yellow-postit

  &.done
    background-color: $green-postit

  &.struckThrough
    text-decoration: line-through  
 
.menuSelected
  border: 1px solid black

.editStyle
  &:hover
    border: 1px solid black

.dropdown-content 
  white-space: pre-line 
  text-align: justify
  font-size: 1.23rem
  padding: 0.2em
  margin-bottom: 0

  -ms-word-break: break-all
  word-break: break-all
  word-break: break-word
  -webkit-hyphens: auto
  -moz-hyphens: auto
  -ms-hyphens: auto
  hyphens: auto

.card-dropdown
    width: 100%

.card-content
  position: relative
  min-height: 3em

  &.containsIcons
    margin-right: 2em

  .myicon
    position: absolute
    right: -1.8em
    top: 0.2em

  .icon-tooltip
    position: absolute
    right: -1.8em
    bottom: 0.1em
    top: auto
    margin: 0

  .my-tooltip
    position: absolute
    right: -2px
    bottom: 3px    


.button-content
  padding: 0.3em

.click-menu
  background: $lightgray-4
  border: 1px solid #BDBDBD
  box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)
  display: block
  list-style: none
  margin: 0
  padding: 0
  position: absolute
  width: 165px
  z-index: 999999

  li 
    border-top: none
    padding: 5px
    cursor: pointer

    &:hover 
      background: scale-color($white, $lightness: -15%)

    &.warning
      background-color: $yellow-postit
      &:hover 
        background: scale-color($yellow-postit, $lightness: -15%)

    &.done
      background-color: $green-postit
      &:hover 
        background: scale-color($green-postit, $lightness: -15%)

    /* &.struckThrough
      text-decoration: line-through  */

    &:fisrt-child 
      border-top: none

    &.separatorBefore 
      border-top: 1px solid $lightgray-1

    .material-design-icon
      margin: 0 0.5em 0 0

</style>



